import { Component } from '@angular/core';
import { ListLinks } from '../../../../../@core/constants/list-links';
import { DataResult, ICRUDOptions } from '@phx-erp/shared';
import { DocumentProject, DocumentProjectSearchInput } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { DocumentProjectDetailWidgetComponent } from '../../../components/document-project-detail-widget/document-project-detail-widget.component';
import { DocumentProjectService } from '../../../services/document-project.service';

@Component({
  selector: 'app-document-project-dropdown',
  template: '',
  providers: [DocumentProjectService],
  standalone: true
})
export class DocumentProjectDropdownComponent extends GenericBaseModelDropDown<DocumentProject> {

  constructor(private service: DocumentProjectService) {
    super(service, "DocumentProject");
    this.listUrl.set(ListLinks.DOCUMENT_PROJECTS);
    this.createNewPopupComponent = DocumentProjectDetailWidgetComponent;
  }

  override executeSearch(searchInput: DocumentProjectSearchInput, options?: ICRUDOptions): Promise<DataResult<any>> {
    searchInput.onlyOfAddressId = this.props.onlyOfAddressId;
    return super.executeSearch(searchInput, options);
  }

}
